import { CounterBadge } from '@wix/design-system';
import { DEFAULT_MESSAGE_READ_DELAY } from '@wix/wix-help-widget-common/duplexer';
import React, { FC } from 'react';
import { useSelector, useStore } from 'react-redux';

import { logChatbotNotifications } from '../../../bi';
import { useDebounce } from '../../../common/hooks/useDebounce';
import { selectUnreadCount } from '../../../common/selectors/chat';
import { renderModel } from '../../../util/renderModel';
import { headerActionsDataHooks } from './HeaderActions.dataHooks';
import s from './styles.scss';

const { duplexer } = renderModel.get();

const debounceTime = duplexer.messageReadDelay ?? DEFAULT_MESSAGE_READ_DELAY; // sec

export const MessageNotificationCounter: FC = () => {
  const store = useStore();
  const state = store.getState();
  const unreadCount = useSelector(selectUnreadCount);

  // we need debounce here to be sure that messages are not read by users in other tabs/devices.
  // we wait few seconds and if we do not receive MESSAGE_READ event we show unread message counter
  const [unreadCountDebounced] = useDebounce(unreadCount, debounceTime * 1000);

  if (unreadCountDebounced === 0) {
    return null;
  }

  logChatbotNotifications(state, {
    counterValue: unreadCount,
  });

  return (
    <div
      className={s.messageNotificationCounter}
      data-hook={headerActionsDataHooks.newMessageNotificationCounter({
        count: unreadCountDebounced,
      })}
    >
      <CounterBadge
        skin="danger"
        size="small"
        dataHook={headerActionsDataHooks.newMessageCounterBadge()}
      >
        {unreadCountDebounced}
      </CounterBadge>
    </div>
  );
};
